import { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Messages from './Messages';
import ChatSender from './ChatSender/ChatSender';
import useMessages from './useMessages';

function ChatConversation({ chatId, onSetTab }) {
  const currentUserId = useSelector((s) => s.user.authUserId);

  const { messages, handleSendMessage, retryUpload, chat } = useMessages(chatId, currentUserId);

  // Get other user ID from chat
  const otherUserId = chat?.user_ids?.find(id => id !== currentUserId);

  const messagesRef = useRef(null);
  const [inputHeight, setInputHeight] = useState(80);

  return (
    <div className="relative h-full">
      <div ref={messagesRef} className="h-full overflow-y-auto" style={{ paddingBottom: inputHeight }}>
        <Messages
          messages={messages}
          chatId={chatId}
          onRetryUpload={retryUpload}
          onSetTab={onSetTab}
        />
      </div>
      <ChatSender onSend={handleSendMessage} chatId={chatId} otherUserId={otherUserId} onHeightChange={setInputHeight} />
    </div>
  );
}

export default ChatConversation;
